export default __webpack_public_path__ + "static/media/item2.8e837b44.png";